import { LeaderboardMultiplier } from '@/types/leaderboard.types';
import { actionLabelMap } from './types';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { plural } from '@/utils/plural';

interface LeaderboardActionSettingCardProps {
  setting: LeaderboardMultiplier;
}

const LeaderboardActionSettingCard: React.FC<LeaderboardActionSettingCardProps> = ({ setting }) => (
  <Container design="GlobalCont3" className="flex flex-column gap-2" borderRadius="12px" padding="12px 16px 12px 16px">
    <Text design="GlobalIcoText1" className="S1" clamp={1}>
      {actionLabelMap[setting.action]}
    </Text>
    <Text design="GlobalIcoText3" className="C2">
      {setting.multiplier} {plural(setting.multiplier, 'Point')}
    </Text>
  </Container>
);

export default LeaderboardActionSettingCard;
